import { BottomNavBar, SideDrawer } from "../../Components/Drawer";
import { lazy, Suspense, useEffect } from "react";
import {
  useTransactionHistoryContext,
  TransactionHistoryProvider,
} from "../../Contexts/TransactionHistoryContext";

const ChoosePolicy = lazy(() => import("./ChoosePolicy"));
const Transactions = lazy(() => import("./Transactions"));
const Details = lazy(() => import("./Details"));

function Fallback() {
  return <div className="w-full m-5 p-5 text-center">Loading ...</div>;
}

function TransactionsHistoryContent() {
  const { currentScreen, getPolicy, setCurrentScreen } =
    useTransactionHistoryContext();

  const urlParams = new URLSearchParams(window.location.search);
  const cardNo = urlParams.get("cardNo");

  useEffect(() => {
    if (cardNo) {
      setCurrentScreen("details");
      getPolicy(cardNo);
    } else {
      setCurrentScreen("choose policy");
    }
  }, []);

  let content = null;

  if (currentScreen === "choose policy") {
    content = (
      <>
        <SideDrawer>
          <ChoosePolicy />
        </SideDrawer>
        <BottomNavBar />
      </>
    );
  }

  if (currentScreen === "transactions") {
    content = (
      <>
        <SideDrawer>
          <Transactions />
        </SideDrawer>
        <BottomNavBar />
      </>
    );
  }

  if (currentScreen === "details") {
    content = <Details />;
  }

  return <Suspense fallback={<Fallback />}>{content}</Suspense>;
}

export default function Index() {
  return (
    <TransactionHistoryProvider>
      <TransactionsHistoryContent />
    </TransactionHistoryProvider>
  );
}
